const carouselItems = [
  {
    tag: '本月重磅',
    title: '古装悬疑巅峰对决',
    desc: '精选十部高分古装悬疑剧，烧脑剧情层层反转，服化道精良，每一帧都是壁纸级别。从朝堂权谋到江湖秘闻，带你领略古代谜案的魅力。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20interior%20with%20golden%20dragon%20pillars%2C%20dramatic%20light%20beams%20through%20lattice%20windows%2C%20mysterious%20atmosphere%20with%20incense%20smoke%2C%20cinematic%20wide%20shot%2C%20warm%20red%20and%20gold%20color%20palette%2C%20historical%20drama%20film%20aesthetic&width=1200&height=600&seq=carousel-01-ancient-palace&orientation=landscape',
  },
  {
    tag: '编辑力荐',
    title: '科幻迷的年度盛宴',
    desc: '硬核科幻巨制集结，从星际穿越到人工智能觉醒，每一部都是想象力与科学的完美碰撞。高清特效震撼视听，科幻爱好者不可错过的饕餮大餐。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20cityscape%20with%20towering%20holographic%20buildings%2C%20flying%20vehicles%20between%20skyscrapers%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20epic%20sci-fi%20cinematic%20composition%2C%20deep%20atmosphere%20with%20vibrant%20color%20accents&width=1200&height=600&seq=carousel-02-scifi-city&orientation=landscape',
  },
  {
    tag: '口碑黑马',
    title: '小成本大惊喜合集',
    desc: '没有大牌明星，没有天价预算，却凭借扎实剧本和精湛演技杀出重围。这些低调佳作用实力证明：好故事才是硬道理。豆瓣均分 8.5+。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20independent%20cinema%20interior%20with%20warm%20ambient%20lighting%2C%20vintage%20movie%20posters%20on%20brick%20wall%2C%20comfortable%20armchairs%2C%20film%20projector%20casting%20warm%20glow%2C%20artistic%20and%20intimate%20atmosphere%2C%20indie%20film%20house%20aesthetic&width=1200&height=600&seq=carousel-03-indie-film&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '那些年我们追过的神作',
    desc: '时光流转，有些作品历久弥新。重温豆瓣 TOP250 经典影片，从《肖申克的救赎》到《千与千寻》，每一部都是影史不可磨灭的印记。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20movie%20theater%20with%20red%20velvet%20curtains%20and%20gold%20trim%2C%20retro%20film%20projector%20in%20foreground%2C%20warm%20nostalgic%20lighting%2C%20empty%20theater%20seats%20in%20soft%20focus%2C%20timeless%20cinema%20atmosphere%2C%20elegant%20vintage%20aesthetic&width=1200&height=600&seq=carousel-04-classic-cinema&orientation=landscape',
  },
  {
    tag: '国漫崛起',
    title: '国产动画新纪元',
    desc: '从《大圣归来》到《哪吒之魔童降世》，国产动画正在经历前所未有的黄金时代。精美国风画面、动人原创故事，每一部都值得细细品味。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20landscape%2C%20traditional%20ink%20wash%20painting%20mountains%20with%20floating%20clouds%2C%20mythical%20phoenix%20soaring%20through%20golden%20sky%2C%20ethereal%20and%20artistic%20composition%2C%20elegant%20oriental%20fantasy%20aesthetic%2C%20soft%20watercolor%20texture&width=1200&height=600&seq=carousel-05-chinese-anime&orientation=landscape',
  },
  {
    tag: '热播综艺',
    title: '话题综艺一网打尽',
    desc: '音乐竞技、旅行慢综、脱口秀、推理探案……各类热门综艺应有尽有。紧跟每周更新节奏，不错过任何一个名场面和话题爆点。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20stage%20with%20bright%20spotlights%20and%20confetti%2C%20energetic%20performance%20atmosphere%2C%20large%20LED%20screens%20showing%20vibrant%20graphics%2C%20entertainment%20show%20production%20set%2C%20dynamic%20and%20lively%20composition&width=1200&height=600&seq=carousel-06-variety-show&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">精选优质内容专题，一站式发现好片</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] w-full overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`悟空影视焦点专题：${item.title}`}
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-900">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}